<template>
    <div>
        <p>This is a <code>.deb</code> package built for Ubuntu/Mint Linux.
            Install it using your system package management tools, such as synaptic,
            Ubuntu software, apt, dpkg, etc. </p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for Linux</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/lin`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp33-deb">Download [{{ size }}]</a>
    </div>
      <h3>Install Java Runtime</h3>
        <p>Java Runtime is NOT included. You have to install it separately using your package manager.
            GanttProject {{ version }} requires Java Runtime version 17, and this package will work with
          Java 17 Runtime from any major vendor, such as BellSoft Liberica, AdoptOpenJDK,
          Amazon Corretto, Azul Zulu, etc. If Java 17 Runtime is not found in your software sources,
          please refer to the instructions from vendors for adding their repositories to your system.</p>
      <p>GanttProject {{ version }} may work with newer Java versions, such as Java 18 or Java 19, however, we do not test it
      and recommend using Java 17.</p>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered via our Update Channel.
        Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time.
        When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
import {gaSendEvent} from "@/components/Analytics";

    export default {
        name: "DownloadLin33",
        props: {
            releaseDate: String,
            size: String,
            version: String,
            virustotalHash: String
        },
      methods: {
        onDownloadStarted: function() {
          gaSendEvent('download_started');
        }
      }
    }
</script>

<style scoped>

</style>
